import React, { useEffect, useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import LabelInsideSelectController from "../../../atoms/InputController/LabelInside/Label-Inside-Select-Controller/LabelInsideSelectController";
import LabelController from "../../../atoms/Label/LabelController";
import { useSelectedClientsJob } from "../../../../slices/jobs/selector";

const JobSection = ({ ...props }) => {
  const { customer, job } = props.newLeadContent;
  const {
    errors,
    touched,
    inputValue,
    customers,
    handleCustomerValues,
    handleJobValues,
  } = props;
  const customersJobs = useSelectedClientsJob();

  const customerOptions = useMemo(() => {
    const baseOption = [
      { value: "", label: "Please Select", isDisabled: true },
    ];

    const customerList = Array.isArray(customers)
      ? customers.map((item) => ({
          value: item.id,
          label: `${item.firstName} ${item.lastName}`,
        }))
      : [];

    return [...baseOption, ...customerList];
  }, [customers]);

  const isJobDropdownVisible = useMemo(() => {
    return customersJobs?.length > 0;
  }, [customersJobs]);

  const jobOptions = useMemo(() => {
    return customersJobs.map((job) => ({
      value: job.id,
      label: job.name,
    }));
  }, [customersJobs]);

  return (
    <div className="box-container">
      <Row>
        <Col sm={6}>
          <LabelController label={customer.label} />
          <LabelInsideSelectController
            value={inputValue[customer.name]}
            name={customer.name}
            label={customer.inputLabel}
            errors={errors}
            options={customerOptions}
            queryName={customer.queryName}
            placeholder={customer.inputLabel}
            onChange={props.onChange}
            touched={touched}
            inputValue={inputValue}
            handleCustomerValues={handleCustomerValues}
          />
        </Col>
        {isJobDropdownVisible && (
          <Col sm={6}>
            <LabelController label={job.label} />
            <LabelInsideSelectController
              value={inputValue[job.name]}
              name={job.name}
              label={job.inputLabel}
              errors={errors}
              options={jobOptions}
              queryName={job.queryName}
              placeholder={job.inputLabel}
              onChange={props.onChange}
              touched={touched}
              inputValue={inputValue}
              handleCustomerValues={handleJobValues}
              disabled={!isJobDropdownVisible}
            />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default JobSection;
